<template>
  <l-tooltip placement="left">
    <div class="flex items-center gap-2">
      <div class="w-2 h-2 rounded-full" :class="status.color"></div>
      {{ status.label }}
    </div>
    <template #content>
      <span v-if="queue?.lastConnection">
        {{ t('printers.last-print') }}
        {{ format(queue.lastConnection, 'HH:mm:ss') }}
      </span>
      <span v-else>{{ t('printers.never-used') }}</span>
      <div v-if="queue?.hasError" class="break-words">
        {{ queue.errorMessage || t('printers.unknown-error') }}
      </div>
    </template>
  </l-tooltip>
</template>

<script setup lang="ts">
import { format } from 'date-fns'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { LTooltip } from '@last/core-ui/paprika'

import type PrinterQueue from '@/integrations/printer/printerQueue'

const { t } = useI18n()

const props = defineProps<{
  queue?: PrinterQueue
}>()

const status = computed(() => {
  const { queue } = props
  if (!queue) {
    return { color: 'bg-n-100', label: t('printers.unknown') }
  }
  if (queue.hasError) {
    return { color: 'bg-r-500', label: t('printers.error') }
  } else if (queue.printing) {
    return { color: 'bg-g-500', label: t('printers.printing') }
  } else if (queue.lastConnection) {
    return { color: 'bg-g-500', label: t('printers.connected') }
  } else {
    return { color: 'bg-n-100', label: t('printers.unknown') }
  }
})
</script>
